import { gql } from '@apollo/client';

export const CREATE_ASSET_MUTATION = gql`
  mutation CreateAsset(
    $name: String!
    $type: String!
    $gold_weight: Float!
    $copper_weight: Float!
    $certificateUrl: String!
    $erc3643Name: String!
    $erc3643Symbol: String!
    $erc3643Decimals: Int!
    $erc3643TotalSupply: String!
    $imageBase64: String
    $availableTokens: Float
    $copper_price: Float
    $pricePerToken: Float
    $tokenizedPercentage: Float
    $stageMultiplier: Float
    $totalTokens: Float
    $minimumInvestmentAmount: Float
    $isActive: Boolean
    $chain: String
    $complianceMode: ComplianceEngine
    $requireAccreditedInvestor: Boolean
  ) {
    createAsset(
      input: {
        name: $name
        type: $type
        gold_weight: $gold_weight
        copper_weight: $copper_weight
        certificateUrl: $certificateUrl
        erc3643Name: $erc3643Name
        erc3643Symbol: $erc3643Symbol
        erc3643Decimals: $erc3643Decimals
        erc3643TotalSupply: $erc3643TotalSupply
        imageBase64: $imageBase64
        availableTokens: $availableTokens
        copper_price: $copper_price
        pricePerToken: $pricePerToken
        tokenizedPercentage: $tokenizedPercentage
        stageMultiplier: $stageMultiplier
        totalTokens: $totalTokens
        minimumInvestmentAmount: $minimumInvestmentAmount
        isActive: $isActive
        chain: $chain
        complianceMode: $complianceMode
        requireAccreditedInvestor: $requireAccreditedInvestor
      }
    ) {
      statusCode
      message
      asset {
        id
        assetId
        name
        type
      }
    }
  }
`;
